import { TranslateModule } from "@ngx-translate/core";
import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-home-features",
  templateUrl: "./home-features.component.html",
  styleUrls: ["./home-features.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
})
export class HomeFeaturesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
